const countries = [
    { value: "Denmark", label: "Danmark" },
    { value: "Sweden", label: "Sverige" },
    { value: "Norway", label: "Norge" },
    { value: "Germany", label: "Tyskland" },
    { value: "USA", label: "USA" },
    { value: "Canada", label: "Kanada" },
    { value: "Australia", label: "Australien" },
    { value: "Andorra", label: "Andorra" },
    { value: "Austria", label: "Österrike" },
    { value: "Belgium", label: "Belgien" },
    { value: "Brazil", label: "Brasilien" },
    { value: "Cyprus", label: "Cypern" },
    { value: "Finland", label: "Finland" },
    { value: "France", label: "Frankrike" },
    { value: "Greece", label: "Grekland" },
    { value: "Iceland", label: "Island" },
    { value: "Ireland", label: "Irland" },
    { value: "Italy", label: "Italien" },
    { value: "Japan", label: "Japan" },
    { value: "Liechtenstein", label: "Liechtenstein" },
    { value: "Luxembourg", label: "Luxemburg" },
    { value: "Latvia", label: "Lettland" },
    { value: "Lithuania", label: "Litauen" },
    { value: "Malta", label: "Malta" },
    { value: "Monaco", label: "Monaco" },
    { value: "Netherlands", label: "Nederländerna" },
    { value: "Portugal", label: "Portugal" },
    { value: "San Marino", label: "San Marino" },
    { value: "Spain", label: "Spanien" },
    { value: "Switzerland", label: "Schweiz" },
    { value: "United Kingdom", label: "Storbritannien" },
    { value: "China", label: "Kina" }
  ];
  
  export default countries;
  


// WEBPACK FOOTER //
// ./src/c/countries/CountriesSe.js